import React from 'react'
import MyPayroll from './MyPayroll'


export default function NewAdmissionRatioReport() {
  return (
    <div>
      <MyPayroll />
    </div>
  )
}
